import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'practice-template/:teamId/patient-ecg-reminder(/:view)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/RemindersContainer',
      './modules/reminders'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Reminders = require('./containers/RemindersContainer').default
      const actions = require('./modules/reminders')
      const reducer = require('./modules/reminders').default
      const auth = require('components/Auth')

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'templateReminders', reducer: reducer })

      store.dispatch(auth.addStorageListener())
      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.teamId, nextState.params.view))

      /*  Return getComponent   */
      cb(null, Reminders)

    /* Webpack named bundle   */
    }, 'templateReminders')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CreateTemplate/components/Reminders/index.js